// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import {buildProductUseAmount} from '../../../product/shared/services/product';

const AmountOfUseModalBody = props =>
    <div className='amount-of-use-modal-body'>
        <ul>
            {props.measurementReadings.map(measurementReading => (
                <li key={measurementReading.useAmount.unit.key}>
                    {buildProductUseAmount(measurementReading.useAmount, measurementReading.date)}
                </li>
            ))}
        </ul>
    </div>;

AmountOfUseModalBody.displayName = 'AmountOfUseModalBody';
AmountOfUseModalBody.propTypes = {
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired
};

export default AmountOfUseModalBody;



// WEBPACK FOOTER //
// ./src/shared/components/amount-of-use-with-modal/amount-of-use-modal-body.js